import { PLAN_TYPES } from 'src/constants/cardsEnum';
import type { OrganizationApiResponseWithPopulatedPlan } from 'src/types/organization';
import { hasActiveOrganizationBillingTrial } from './organizationBilling';

const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const DEFAULT_HANA_PRO_TRIAL_DURATION_DAYS = 14;

export interface HanaProTrialStatus {
  durationDays: number;
  remainingDays: number;
  endDate: Date;
  isActive: boolean;
}

export const getHanaProTrialStatus = (
  organizationDetails?: Partial<OrganizationApiResponseWithPopulatedPlan> | null,
  now: Date = new Date(),
): HanaProTrialStatus | null => {
  const billingTrial = organizationDetails?.billingTrial;

  if (billingTrial) {
    const endDate = new Date(billingTrial.endsAt);
    const startedAt = new Date(billingTrial.startedAt);

    if (
      !Number.isNaN(endDate.getTime()) &&
      !Number.isNaN(startedAt.getTime())
    ) {
      const durationDays = Math.max(
        1,
        Math.ceil((endDate.getTime() - startedAt.getTime()) / DAY_IN_MS),
      );
      const remainingDays = Math.max(
        0,
        Math.ceil((endDate.getTime() - now.getTime()) / DAY_IN_MS),
      );

      return {
        durationDays,
        remainingDays,
        endDate,
        isActive: hasActiveOrganizationBillingTrial(organizationDetails, now),
      };
    }
  }

  if (!organizationDetails?.createdAt) {
    return null;
  }

  if (organizationDetails.planId?.displayName !== PLAN_TYPES.FREE) {
    return null;
  }

  const createdAt = new Date(organizationDetails.createdAt);

  if (Number.isNaN(createdAt.getTime())) {
    return null;
  }

  const endDate = new Date(
    createdAt.getTime() + DEFAULT_HANA_PRO_TRIAL_DURATION_DAYS * DAY_IN_MS,
  );
  const remainingDays = Math.max(
    0,
    Math.ceil((endDate.getTime() - now.getTime()) / DAY_IN_MS),
  );

  return {
    durationDays: DEFAULT_HANA_PRO_TRIAL_DURATION_DAYS,
    remainingDays,
    endDate,
    isActive: remainingDays > 0,
  };
};
